import { getRcpoModelPrimaryAttributes } from '../../../lib/get-rcpo-model-primary-attributes'
import { Heading } from '../ui/Heading'
import { Text } from '../ui/Text'
import { Article } from '@generated'
import { formatPrice } from '@lib/formatPrice'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

type BasicInfoProps = {
  data: Article
}

export const BasicInfo: FC<BasicInfoProps> = ({ data }) => {
  const { t } = useTranslation('roles')
  const primaryAttributes = getRcpoModelPrimaryAttributes(data)

  return (
    <>
      <Heading as="span" variant="very-small-title" className="mb-2 block text-current">
        Rolex Certified Pre-Owned
      </Heading>
      <Heading as="span" variant="medium" className="mb-[10px] text-current">
        {data.modelName}
      </Heading>
      <Text variant="regular" className="mb-1 mt-[10px] block text-current">
        {primaryAttributes}
      </Text>
      <Text variant="regular" className="block text-current">
        {data.supplierNr && `${t('specs.reference', { ns: 'rolex' })}: ${data.supplierNr}`}
      </Text>
      {data.supplierNr && (
        <Text variant="regular" className="block text-current">
          {t('detail.price', { ns: 'rolex' })}:
          <span className="font-bold"> {formatPrice(data?.price || 0)}</span>
        </Text>
      )}
    </>
  )
}
